<template>
  <div>
    <!--  仓库地址维护-->
    <baseBreadcrumb :page="$t('message.warehouseAddressMaintenance')" :menu="$t('message.operationAndMaintenance')" />
    <div class="body">
      <div class="add">
        <!-- 新建 -->
        <el-button type="primary" size="small" @click="add" v-if="isAuth(437)">{{ $t('message.newBuild') }} </el-button>
      </div>
      <el-tabs v-model="datas.type" type="card" @tab-click="addressThirdPartyList">
        <!-- 全部 -->
        <el-tab-pane :label="item.name" :name="item.type + ''" v-for="(item, index) in tabsList"
          :key="index"></el-tab-pane>
      </el-tabs>
      <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
        :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">
        <!-- NO -->
        <el-table-column align="center" label="NO" type="index" width="80">
        </el-table-column>
        <!-- 仓库编码 -->
        <el-table-column align="center" :label="$t('message.warehouseCode')" prop="sn" width="120">
        </el-table-column>
        <!-- 手机号 -->
        <el-table-column align="center" :label="$t('message.mobile')" prop="mobile" width="120">
        </el-table-column>
        <!-- 仓库名 -->
        <el-table-column align="center" :label="$t('message.nameOfWarehouse')" prop="name" width="200">
        </el-table-column>
        <!-- 仓库地址（日文） -->
        <el-table-column align="center" :label="$t('message.warehouseAddress_Japanese')" prop="address_jpn">
        </el-table-column>
        <!-- 仓库地址（英文） -->
        <el-table-column align="center" :label="$t('message.warehouseAddress_English')" prop="address_en">
        </el-table-column>
        <!-- 邮编 -->
        <el-table-column align="center" :label="$t('message.zip_code')" prop="zip" width="120">
        </el-table-column>
        <!-- 启用状态 -->
        <el-table-column align="center" :label="$t('message.statusOfEnable')" prop="sort" width="120">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status_flag" active-color="#13ce66"
              @change="addressThirdPartySave(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column align="center" :label="$t('message.operation')" prop="sort" width="200">
          <template slot-scope="scope">
            <!-- 编辑 -->
            <el-button type="primary" size="mini" @click="edit(scope.row)" v-if="isAuth(437)">{{ $t('message.redact')
              }}</el-button>
            <!-- 删除 -->
            <el-button type="danger" size="mini" @click="delItem(scope.row.id)" v-if="isAuth(438)">
              {{ $t('message.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 新增编辑 -->
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="dialogVisible" width="580px" center>
      <div class="content">
        <el-form :model="itemData" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
          <!-- 仓库类别： -->
          <el-form-item :label="$t('message.typeOfWarehouse')" prop="name">
            <el-select v-model="itemData.type" placeholder="请选择">
              <el-option v-for="item in tabsList" :key="item.type" :label="item.name" :value="item.type">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 仓库编码 -->
          <el-form-item :label="$t('message.warehouseCode')" prop="name">
            <el-input v-model="itemData.sn"></el-input>
          </el-form-item>
          <!-- 仓库编码 -->
          <el-form-item :label="$t('message.mobile')" prop="name">
            <el-input v-model="itemData.mobile"></el-input>
          </el-form-item>
          <!-- 仓库名 -->
          <el-form-item :label="$t('message.nameOfWarehouse')" prop="name">
            <el-input v-model="itemData.name"></el-input>
          </el-form-item>
          <!-- 邮编 -->
          <el-form-item :label="$t('message.zip_code')" prop="name">
            <el-input v-model="itemData.zip"></el-input>
          </el-form-item>
          <!-- 仓库地址（日文） -->
          <el-form-item :label="$t('message.warehouseAddress_Japanese')" prop="address_jpn">
            <el-input v-model="itemData.address_jpn" type="textarea" resize="none"></el-input>
          </el-form-item>
          <!-- 仓库地址（英文） -->
          <el-form-item :label="$t('message.warehouseAddress_English')" prop="address_en">
            <el-input v-model="itemData.address_en" type="textarea" resize="none"></el-input>
          </el-form-item>
          <!-- 是否启用 -->
          <el-form-item :label="$t('message.whetherEnabled')" prop="name">
            <el-radio v-model="itemData.status" :label="1">启用</el-radio>
            <el-radio v-model="itemData.status" :label="0">不启用</el-radio>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
      $t("message.cancel")
    }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
      $t("message.ok")
          }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabsList: [],
      tableData: [],
      datas: {
        type: '1'
      },
      //新增编辑用
      title: '',
      dialogVisible: false,
      itemData: {},
      rules: {
        address_jpn: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        address_en: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },]
      },
    };
  },
  created() {
    this.$api.siteConfiguration.addressThirdPartyGroup().then(res => {
      this.tabsList = res.data
    })
    this.addressThirdPartyList()
  },
  methods: {
    addressThirdPartyList() {
      this.$api.siteConfiguration.addressThirdPartyList(this.datas).then(res => {
        res.data.forEach(item => {
          item.status_flag = item.status == 1 ? true : false
        })
        this.tableData = res.data
      })
    },
    // 第三方仓库地址保存
    addressThirdPartySave(item) {
      item.status = item.status_flag ? 1 : 0
      this.$api.siteConfiguration.addressThirdPartySave(item).then(res => {
        this.$message.success(res.msg)
      })
    },
    //删除仓库
    delItem(id) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.siteConfiguration.addressThirdPartyDelete({ id }).then(res => {
            this.$message.success(res.msg);

            this.addressThirdPartyList();
          });
        })
        .catch(() => { });

    },
    //新增仓库
    add() {
      this.title = this.$t('message.add_Warehouse')
      this.itemData = {
        type: '',
        sn: '',
        name: '',
        zip: '',
        address_jpn: '',
        address_en: '',
        status: 1,
      }
      this.dialogVisible = true
    },
    //编辑
    edit(item) {
      this.title = this.$t('message.edit_Warehouse')
      this.itemData = JSON.parse(JSON.stringify(item))
      this.dialogVisible = true
    },
    //保存
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$api.siteConfiguration.addressThirdPartySave(this.itemData).then(res => {
            this.$message.success(res.msg)
            this.addressThirdPartyList()
            this.dialogVisible = false
          })
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.add {
  position: relative;

  .el-button {
    position: absolute;
    top: 00px;
    right: 10px;
    z-index: 99;
  }
}

.content {
  padding: 0 20px;

  .el-select {
    width: 100%;
  }
}
</style>